module.exports = __webpack_public_path__ + "img/career-b1.d22df2c3.jpg";